import React from "react";
import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, FileText, MessageSquare, Quote, Download, LogOut, Users, Building2, Award, Settings } from "lucide-react";

const ITEMS = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
  { to: "/admin/blog", label: "Articles", icon: FileText },
  { to: "/admin/team", label: "Équipe", icon: Users },
  { to: "/admin/clients", label: "Logos clients", icon: Building2 },
  { to: "/admin/references", label: "Références", icon: Award },
  { to: "/admin/testimonials", label: "Témoignages", icon: Quote },
  { to: "/admin/resources", label: "Ressources", icon: Download },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/settings", label: "Réglages", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const loc = useLocation();

  if (user === null) return <div className="min-h-screen flex items-center justify-center text-ink/50">Chargement…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" state={{ from: loc }} replace />;

  return (
    <div className="min-h-screen bg-paper-2">
      <aside className="fixed left-0 top-0 bottom-0 w-64 bg-brand-deep text-white flex flex-col">
        <div className="p-6 border-b border-white/10">
          <img src="/brand/wedo_logo_2024.png" alt="WeDo" className="h-14 invert brightness-0 contrast-200" />
          <p className="text-xs uppercase tracking-widest text-white/40 mt-3">Back-office</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {ITEMS.map(it => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`admin-nav-${it.to.replace(/\//g, '-')}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm rounded-sm transition-colors ${
                  isActive ? "bg-white/10 text-white" : "text-white/65 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <it.icon size={16}/>
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="px-4 py-2 mb-2">
            <p className="text-xs text-white/40">Connecté en tant que</p>
            <p className="text-sm text-white truncate">{user.email}</p>
          </div>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-white/65 hover:text-white hover:bg-white/5 rounded-sm transition-colors"
          >
            <LogOut size={16}/> Se déconnecter
          </button>
        </div>
      </aside>
      <main className="ml-64 min-h-screen p-10">
        <Outlet />
      </main>
    </div>
  );
}
